import React from 'react';
import ReactDOM from 'react-dom/client';

import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
//import 'primereact/resources/primereact.css';

//import '@mdi/font/css/materialdesignicons.min.css';
import './styles/App.scss';
import './styles/index.css';

import "./assets/theme/theme.scss";

import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode> - Wyłączone dla lepszej wydajności w trybie deweloperskim
      <BrowserRouter>
        <App />
    </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
